import React from 'react';
import UserContext, { IUserContext } from './UserContext'
import { LoginInput } from 'api'
import { RouteComponentProps, Redirect, } from 'react-router';
import { appModule } from 'services/module'

class LoginPage extends React.Component<RouteComponentProps<any>, { model: LoginInput, loading: boolean }> {
	state = {
		model: {
			account: '',
			entCode: '',
			password: '',
			rememberMe: false,
			systemCode: ''
		},
		loading: false
	}

	onLogin = async (userContext: IUserContext) => {

		if (this.refUserName.current.value === "") return;
		if (this.refPassword.current.value === "") return;

		if (this.state.loading) return;

		let loading = true;
		this.setState({ loading });


		const locationState = this.props.location.state as any;
		const from = locationState.from || { pathname: "/" };
		let systemCode = appModule.getSysCodeByPath(from.pathname);

		let model = { ...this.state.model, account: this.refUserName.current.value, password: this.refPassword.current.value, systemCode }
		let user = await userContext.login(model);
		if (!user.isLogin) {
			loading = false;
			this.setState({ loading });
		}
	}

	refUserName = React.createRef<HTMLInputElement>();
	refPassword = React.createRef<HTMLInputElement>();

	renderForm = (userContext: IUserContext) => {
		let { model } = this.state;
		return (
			<div className='app-login-container'>
				{/* <div className='app-company-title'></div>		 */}
				<div className='app-login-content'>
					<div className='app-login-title'>用户登录</div>
					<div className='app-login-input'>
						<div className='app-login-input-username'>
							<input type="text" ref={this.refUserName} />
							<span className='username-logo'></span>
						</div>
						<div className='app-login-input-password'>
							<input type="password" ref={this.refPassword} />
							<span className='password-logo'></span>
						</div>
					</div>
					<button onClick={() => { this.onLogin(userContext) }}>
						{this.state.loading ? '登 录 中...' : '登 录'}

					</button>
				</div>
			</div>
		)

	}
	render() {
		const locationState = this.props.location.state as any;
		const from = (undefined !== locationState && 'form' in locationState) ? locationState.form : { pathname: "/" };


		return (<UserContext.Consumer>
			{userContext => {
				if (userContext.user.isLogin) {
					return <Redirect to={from} />;
				} else {
					return this.renderForm(userContext)
				}
			}}
		</UserContext.Consumer>)
	}
}
export default LoginPage


// WEBPACK FOOTER //
// ./src/modules/User/Login.tsx